module.exports = __webpack_public_path__ + "static/media/FilmAvater.fd3657bf.jpg";